document.addEventListener("DOMContentLoaded", function() {
  // Simple function to add our click handler
  function setupRatingClickHandlers() {
    // Find all product rating elements
    var ratingElements = document.querySelectorAll('.product__rating');
    
    // Add click handlers to each rating element
    ratingElements.forEach(function(element) {
      // Only add handler if we haven't already (prevent duplicates)
      if (!element.classList.contains('has-click-handler')) {
        element.classList.add('has-click-handler');
        element.style.cursor = 'pointer';
        
        element.addEventListener('click', function() {
          // If not clicking on a link or interactive element
          if (!event.target.closest('a, button')) {
            scrollToReviews();
          }
        });
      }
    });
  }
  
  // Function to scroll to reviews
  function scrollToReviews() {
    // Try multiple approaches to find the reviews section
    
    // First, try to find Okendo reviews by various selectors
    var reviewsSection = 
        document.getElementById('shopify-block-Aa1lGRHYzMVdxaEhWO__okendo_reviews_widget_Nzxxw9') || 
        document.querySelector('.okeReviews') ||
        document.querySelector('[data-oke-reviews-widget]') ||
        document.querySelector('#oke-reviews') ||
        document.querySelector('.oke-w-reviews');
    
    // If not found, look for the section containing "reviews" in its ID or class
    if (!reviewsSection) {
      var sections = document.querySelectorAll('section, div.shopify-section');
      for (var i = 0; i < sections.length; i++) {
        var sectionId = sections[i].id || '';
        var sectionClass = sections[i].className || '';
        
        if (sectionId.toLowerCase().indexOf('review') !== -1 || 
            sectionClass.toLowerCase().indexOf('review') !== -1) {
          reviewsSection = sections[i];
          break;
        }
      }
    }
    
    // If still not found, try looking for elements with "review" in their text content
    if (!reviewsSection) {
      var elements = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].textContent.toLowerCase().indexOf('review') !== -1) {
          // Use the nearest section or large container
          reviewsSection = elements[i].closest('section') || 
                          elements[i].closest('.shopify-section') || 
                          elements[i];
          break;
        }
      }
    }
    
    // If all else fails, use a position-based approach
    if (!reviewsSection) {
      // Look for the apps section which is likely where reviews are
      reviewsSection = document.getElementById('shopify-section-17311744457c93eaad');
    }
    
    // If we found a reviews section, scroll to it
    if (reviewsSection) {
      var headerOffset = 100; // Adjust based on your header height
      var elementPosition = reviewsSection.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      // Scroll to the element
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      return true;
    } else {
      // If all else fails, scroll 70% down the page as a fallback
      var pageHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      
      window.scrollTo({
        top: pageHeight * 0.7,
        behavior: 'smooth'
      });
      
      return false;
    }
  }
  
  // Run immediately
  setupRatingClickHandlers();
  
  // Also run after a delay to catch dynamically loaded elements
  setTimeout(setupRatingClickHandlers, 1000);
  
  // For good measure, run periodically to catch any late-loading elements
  setInterval(setupRatingClickHandlers, 3000);
  
  // Expose function globally so it can be called from inline code if needed
  window.scrollToReviews = scrollToReviews;
});